'use client'
import { ReactNode } from 'react';
import styles from './AuthLayout.module.css';
import { Logo } from '@practium/ui';

interface AuthLayoutProps {
	title: string;
	subtitle?: ReactNode;
	children: ReactNode;
	promoPanel?: ReactNode;
	logoClassName?: string;
	headerClassName?: string;
}

export const AuthLayout = ({ title, subtitle, children, promoPanel, logoClassName, headerClassName }: AuthLayoutProps) => {
	return (
		<div className={styles.container}>
			<div className={styles.leftPanel}>
				<div className={styles.content}>
					<div className={`${styles.logoContainer} ${logoClassName ?? ''}`}>
						<Logo />
					</div>

					<div className={`${styles.header} ${headerClassName ?? ''}`}>
						<h1 className={styles.title}>{title}</h1>
						{subtitle && <div className={styles.subtitle}>{subtitle}</div>}
					</div>

					<div className={styles.formContainer}>{children}</div>
				</div>
			</div>

			{promoPanel && <div className={styles.rightPanel}>{promoPanel}</div>}
		</div>
	);
};
